import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Nav, NavItem, TabContent, NavLink, TabPane } from "reactstrap";
import { Link } from "react-router-dom";
import usdt from "../../assets/images/coin/usdt.png"
import polygon from "../../assets/images/coin/polygon.webp"
import euro from "../../assets/images/coin/euro.png"
import { withRouter, useHistory } from "react-router-dom";
import classname from "classnames";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import "../../assets/scss/custom/style.css";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { formatCurrency, formatDate } from '../../Utils/formatters';


const UserWallet = (props) => {
  //meta title
  document.title = "User Wallet";
  const history = useHistory();
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
        variant: '',
        message: '',
    });
    const resetAlertData = () => {
        setTimeout(() => {
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: '',
                message: '',
            }));
        }, 5000);
    };

  
  const [activeTab, setActiveTab] = useState("3");
  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const [T1BodyData, setT1BodyData] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.hash}</td>
        <td>{element.type}</td>
        <td>{element.value} {element.token_symbol}</td>
        <td>{element.type === 'Send'? element.to_contract_address : element.from_contract_address}</td>
      </tr>
    ));

    setT1BodyData(tempTBody);
  }
  
  const [T2BodyData, setT2BodyData] = React.useState('');
  const handleT2Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.hash}</td>
        <td>{element.type}</td>
        <td>{element.value} {element.token_symbol}</td>
        <td>{element.type === 'Send'? element.to_contract_address : element.from_contract_address}</td>
      </tr>
    ));

    setT2BodyData(tempTBody);
  }

  const [T3BodyData, setT3BodyData] = React.useState('');
  const handleT3Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.ft_id}</td>
        <td>{formatDate(element.created_at)}</td>
        <td>{formatCurrency(element.amount)}</td>
        <td>{element.type}</td>
        <td>{element.description}</td>
        <td>{formatCurrency(element.balance)}</td>
      </tr>
    ));

    setT3BodyData(tempTBody);
  }

  const [ CryptoData, setCryptoData ] = React.useState([]);
  const handleLoadGetCryptoData = async () => {
    const jsonpar = JSON.stringify({
      u_id: atob(props.match.params.id)
    });
    const res = await postRequest('get-crypto-data', jsonpar);
    if (res && res.code === 200) {
      setCryptoData(res.data);

      if(res.data.crypto_transaction.length > 0) {
        const filteredTransactions1 = res.data.crypto_transaction.filter(transaction => transaction.token_symbol === 'MATIC');
        const filteredTransactions2 = res.data.crypto_transaction.filter(transaction => transaction.token_symbol === 'USDT');
        if(filteredTransactions1.length > 0) {
          handleT1Body(filteredTransactions1);
        }
        else {
          let tempTBody = (<tr>
                          <td colSpan="4" className="text-center">No records found</td>
                        </tr>);

          setT1BodyData(tempTBody);
        }

        if(filteredTransactions2.length > 0) {
          handleT2Body(filteredTransactions2);
        }
        else {
          let tempTBody = (<tr>
                          <td colSpan="4" className="text-center">No records found</td>
                        </tr>);

          setT2BodyData(tempTBody);
        }
      }
      else {
        let tempTBody = (<tr>
                        <td colSpan="4" className="text-center">No records found</td>
                      </tr>);

        setT1BodyData(tempTBody);
        setT2BodyData(tempTBody);
      }
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="4" className="text-center">No records found</td>
                      </tr>);

      setT1BodyData(tempTBody);
      setT2BodyData(tempTBody);
    }
  }

  const handleLoadGetFiatData = async () => {
    const jsonpar = JSON.stringify({
      u_id: atob(props.match.params.id),
      currency_type: 'Euro',
    });
    const res = await postRequest('get-fiat-data', jsonpar);
    if (res && res.code === 200) {
      handleT3Body(res.data);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="6" className="text-center">No records found</td>
                      </tr>);

      setT3BodyData(tempTBody);
    }
  }
  React.useEffect(() => {
    if (!props.match.params.id) {
      history.push({
        pathname: '/user_management',
        state: { code: 401, status: 'error', message: 'ID not found! Please provide a valid ID.' }
      });
        }
    else {
      handleLoadGetCryptoData();
      handleLoadGetFiatData();
    }
  }, []);

  
  return (
    <React.Fragment>
            {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content common-width">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Tokenizedgreen" breadcrumbItem="User Wallet" />
          <Row>
            <Col xs="12">
              <Row>
                <Col lg="12">
                  <Nav tabs className="nav-tabs-custom mb-3 border-0 activeTab" role="tablist">
                    <NavItem>
                      <NavLink className={classname({ active: activeTab === "3", })} onClick={() => { toggleTab("3"); }}>Euro</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classname({ active: activeTab === "1", })} onClick={() => { toggleTab("1"); }}>Polygon Matic</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classname({ active: activeTab === "2", })} onClick={() => { toggleTab("2"); }}>USDT</NavLink>
                    </NavItem>
                    <Link to="/withdrawal_request" className="back-link"><i className="bx bx-left-arrow-alt"></i> Back</Link>
                  </Nav>
                  <TabContent activeTab={activeTab} className="crypto-buy-sell-nav-content" >
                    <TabPane tabId="1" id="01">
                      <Row>
                        <Col xs={12}>
                          <Card>
                            <CardBody className="border-top">
                              <Row>
                                <div className="maticBox">
                                  <div className="d-flex">
                                    <div className="me-2">
                                      <img src={polygon} className="img-fluid crypto-coin" />
                                    </div>
                                    <div className="flex-grow-1">
                                      <div className="text-muted">
                                        <h5>Polygon Matic</h5>
                                        <p className="mb-1 wordBreak">Wallet Addresss : {CryptoData.wallet_address}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="maticBox1">
                                  <div className="text-end">
                                    <p className="text-muted mb-2">Available Balance</p>
                                    <h5>{CryptoData.matic_available_balance} MATIC</h5>
                                  </div>
                                </div>
                                <div className="maticBox2">
                                  <div className="text-end">
                                    <p className="text-muted mb-2">Pending Balance</p>
                                    <h5>{CryptoData.matic_pending_balance} MATIC</h5>
                                  </div>
                                </div>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col xs={12}>
                          <Card>
                            <CardBody>
                              <h5 className="mb-3">Recent Transaction</h5>
                              <div className="table-rep-plugin">
                                <div className="table-responsive mb-0" >
                                  <table className="table mb-0" style={{ minWidth: "1000px" }}>
                                    <thead className="table-light">
                                      <tr>
                                        <th>Transaction Hash</th>
                                        <th>Type</th>
                                        <th>Amount</th>
                                        <th>Recipient</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {T1BodyData}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="2" id="02">
                      <Row>
                        <Col xs={12}>
                          <Card>
                            <CardBody className="border-top">
                              <Row>
                                <div className="maticBox">
                                  <div className="d-flex">
                                    <div className="me-2">
                                      <img src={usdt} className="img-fluid crypto-coin" />
                                    </div>
                                    <div className="flex-grow-1">
                                      <div className="text-muted">
                                        <h5>USDT</h5>
                                        <p className="mb-1 wordBreak">Wallet Addresss : {CryptoData.wallet_address}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="maticBox1">
                                  <div className="text-end">
                                    <p className="text-muted mb-2">Available Balance</p>
                                    <h5>{CryptoData.usdt_available_balance} USDT</h5>
                                  </div>
                                </div>
                                <div className="maticBox2">
                                  <div className="text-end">
                                    <p className="text-muted mb-2">Pending Balance</p>
                                    <h5>{CryptoData.usdt_pending_balance} USDT</h5>
                                  </div>
                                </div>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col xs={12}>
                          <Card>
                            <CardBody>
                              <h5 className="mb-3">Recent Transaction</h5>
                              <div className="table-rep-plugin">
                                <div className="table-responsive mb-0" >
                                  <table className="table mb-0" style={{ minWidth: "1000px" }}>
                                    <thead className="table-light">
                                      <tr>
                                        <th>Transaction Hash</th>
                                        <th>Type</th>
                                        <th>Amount</th>
                                        <th>Recipient</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {T2BodyData}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="3" id="03">
                      <Row>
                        <Col xs={12}>
                          <Card>
                            <CardBody>
                              <div className="d-flex">
                                <div className="me-2">
                                  <img src={euro} className="img-fluid crypto-coin" />
                                </div>
                                <div className="flex-grow-1">
                                  <div className="text-muted">
                                    <h5>Euro</h5>
                                    <p className="mb-1">Available Balance : {formatCurrency(CryptoData.euro_available_balance)}</p>
                                  </div>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col xs={12}>
                          <Card>
                            <CardBody>
                              <h5 className="mb-3">Recent Transaction</h5>
                              <div className="table-rep-plugin">
                                <div className="table-responsive mb-0">
                                  <table className="table mb-0" style={{ minWidth: "1000px" }}>
                                    <thead className="table-light">
                                      <tr>
                                        <th>ID</th>
                                        <th>Date</th>
                                        <th>Amount</th>
                                        <th>Type</th>
                                        <th>Description</th>
                                        <th>Balance</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {T3BodyData}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserWallet);
